import React, { Fragment, useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import { fetchData, updateData, postData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { Tooltip } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import Select from 'react-select';
import EditIcon from '@mui/icons-material/Edit';
import DatePicker from 'react-datepicker';
import CancelIcon from '@mui/icons-material/Cancel';
import SaveIcon from '@mui/icons-material/Save';
import SendIcon from '@mui/icons-material/Send';
import axios from 'axios';
import Modal from '@mui/material/Modal';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';


function OfficeEditPage() {
    const history = useHistory();
    const { id } = useParams(); // Assuming you're passing the expense ID through the URL
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();
    const [note, setNote] = useState('');
    const [amount, setAmount] = useState('');
    const [selectedExpenseType, setSelectedExpenseType] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [itemList, setItemList] = useState([]);
    const [newItem, setNewItem] = useState({});
    const [selectedOption, setSelectedOption] = useState('');

    const [selectedDate, setSelectedDate] = useState(new Date());
    const [formData, setFormData] = useState({
        ExpenseID: '',
        CompanyID: '',
        EngineerID: '',
        EngineerName: '',
        ExpenseName: '',
        Amount: '',
        Note: '',
        ExpenseEntryDate: '',
        ModifiedBy: userId,

    });

    const [itemdata, setData] = useState([]);

    useEffect(() => {
        fetchData('ExpenseApi', `/ ExpenseDetails/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setData(response.response_data);
                    console.log(response);

                }

                setFormData((prevData) => ({
                    ...prevData,
                    ModifiedBy: userId,
                }));

            })
            .catch((error) => {
                console.error('Error fetching Sale Details:', error);
            });
    }, [id]);


    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        const updatedData = {
            Note: note,
            Amount: amount,
            ExpenseType: selectedExpenseType,
            ExpenseEntryDate: selectedDate,

        };

        try {
            const response = await updateData(`ExpenseApi/${id}`, updatedData);
            if (response.responseCode === '1111') {
                console.log('Expense updated successfully:', response.responseMessage);
                history.push('/OfficeIndex');
            } else {
                console.error('Error updating expense:', response.responseMessage);
            }
        } catch (error) {
            console.error('Error updating expense:', error);
        }

        setIsLoading(false);
    };

    const ApprovedClaims = async (item) => {
        try {

            const Claims = {
                ExpenseID: item.expenseID,
                ExpenseItemID: item.expenseItemID,
                isApproved: true,
                modifiedBy: userId
            };

            const expenseId = item.expenseID;
            // Make the PUT request using axios
            // const response = await axios.put(`https://localhost:7291/api/ExpenseApi/${expenseId}`, Claims, {
            const response = await axios.put(`https://pp-api.off-ease.com/api/ExpenseApi/${expenseId}`, Claims, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setIsLoading(false);
            console.log('Claim Approve successed:', response.data);

            setTimeout(() => {
                window.location.reload();
            }, 3000);
        } catch (error) {
            console.error('Claim Approved error:', error);
        }
    };


    // Rejected Claims
    const RejectedClaims = async (item) => {
        try {

            const Claims = {
                ExpenseID: item.expenseID,
                ExpenseItemID: item.expenseItemID,
                IsRejected: true,
                modifiedBy: userId
            };

            const expenseId = item.expenseID;
            // Make the PUT request using axios
            // const response = await axios.put(`https://localhost:7291/api/ExpenseApi/${expenseId}`, Claims, {
            const response = await axios.put(`https://pp-api.off-ease.com/api/ExpenseApi/${expenseId}`, Claims, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setIsLoading(false);

            console.log('Claim Approve successed:', response.data);


            setTimeout(() => {
                window.location.reload();
            }, 3000);
        } catch (error) {
            console.error('Claim Approved error:', error);
        }
    };

    return (
        <div className="w-full max-w-sm container mt-6 mx-auto">

            <div className='w-full mb-2 flex'>
                <h6 className='productHead flex-grow linkcolor' style={{ color: 'black', fontFamily: 'Georgia, serif', fontWeight: 'bolder' }}>CLAIM DETAILS</h6>
                <div className="button-container-2">

                    <Tooltip title="Exit">
                        <Link to="/OfficeIndex" style={{ marginTop: '-30px', color: 'red', textDecoration: 'none', fontWeight: 'bolder' }}>
                            <Button style={{ color: 'red', fontWeight: 'bolder' }}>
                                Back TO lIST<ArrowForwardIosIcon />
                            </Button>
                        </Link>
                    </Tooltip>

                    {/* <Tooltip title="Submit">

                        <Button onClick={handleSubmit} style={{ color: 'green' }} disabled={isLoading}>
                            {isLoading ? <CircularProgress size={24} color="inherit" /> : "Save"} <CheckCircleIcon />
                        </Button>

                    </Tooltip> */}
                </div>
            </div >

            <div className="overflow-auto" style={{ overflowY: 'auto' }}>
                <table className="w-full border-collapse border" style={{ overflowY: 'auto' }}>
                    <thead>
                        <tr className="bg-gray-200 border-b">
                            <th className="px-4 py-2 text-left border-r" style={{ padding: '4px', width: '5px', textTransform: 'uppercase', fontSize: '12px' }}>Sl.no</th>
                            <th className="px-4 py-2 text-left border-r" style={{ padding: '4px', width: '500px', textTransform: 'uppercase', fontSize: '12px' }}>Expense</th>
                            <th className="px-4 py-2 text-left border-r" style={{ padding: '4px', width: '500px', textTransform: 'uppercase', fontSize: '12px' }}>Note</th>
                            <th className="px-4 py-2 text-left border-r" style={{ padding: '4px', width: '150px', textTransform: 'uppercase', fontSize: '12px', textAlign: 'right' }}>Amount</th>
                            <th style={{ padding: '4px', width: '150px', fontSize: '12px' }}></th>
                            {/* <th style={{ padding: '8px' }}></th> */}
                        </tr>
                    </thead>
                    <tbody style={{ backgroundColor: ' white' }}>
                        {itemdata.map((item, index) => (
                            <tr key={index} className={`${item.isApproved ? 'bg-green-200' : ''} ${item.isRejected ? 'bg-red-200' : ''}`}>

                                <td className="px-4 py-2 border-r" style={{ width: '5px', fontSize: '13px' }}>{index + 1}</td>
                                <td className="px-4 py-2 border-r" style={{ width: '500px', fontSize: '13px' }}>{item.expenseName}</td>
                                <td className="px-4 py-2 border-r" style={{ width: '500px', fontSize: '13px' }}>{item.note}</td>
                                <td className="px-4 py-2 border-r" style={{ width: '150px', textAlign: 'right', cursor: 'pointer', fontSize: '13px', fontWeight: 'bolder' }}>{item.amount}</td>

                                <Fragment>
                                    {item.isApproved && (
                                        <td style={{ padding: '8px', marginTop: '-15px' }}>
                                            <span style={{ color: 'green', marginLeft: '20px', fontWeight: 'bolder' }}>Approved</span>
                                        </td>
                                    )}
                                    {item.isRejected && (
                                        <td style={{ padding: '8px', marginTop: '-15px' }}>
                                            <span style={{ color: 'red', marginLeft: '20px', fontWeight: 'bolder' }}>Rejected</span>
                                        </td>
                                    )}
                                    {!item.isApproved && !item.isRejected && (
                                        <td style={{ padding: '8px', marginTop: '-15px' }}>
                                            <Tooltip title="Approve">
                                                <IconButton
                                                    style={{ padding: '8px', marginTop: '-10px', color: 'green', marginRight: '5px' }}
                                                    onClick={() => ApprovedClaims(item)}
                                                >
                                                    <CheckCircleIcon />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title="Reject">
                                                <IconButton
                                                    style={{ padding: '8px', marginTop: '-10px', color: 'red' }}
                                                    onClick={() => RejectedClaims(item)}
                                                >
                                                    <CancelIcon />
                                                </IconButton>
                                            </Tooltip>
                                        </td>
                                    )}
                                </Fragment>
                            </tr>
                        ))}



                    </tbody>
                </table>
            </div>



        </div >
    );
}


export default OfficeEditPage;
